import axios from "../../api/axiosInstance";

const BASE = process.env.REACT_APP_API_URL;

/**
 * @param {Object} [options]
 * @param {boolean} [options.trialOrgSkip]
 * @param {string|number|null} [options.projectId] - Pass from project-scoped (automation) screens so the
 *   permission middleware evaluates the caller's project-scoped roles. Omit on org-level screens (config,
 *   AI generation) where the user passes via org-level permissions and may not be a project member.
 */
export async function getFeatureMappings(options = {}) {
  if (options.trialOrgSkip) {
    return Promise.resolve({ data: { success: true, data: [] } });
  }
  const query =
    options.projectId != null && options.projectId !== ""
      ? `?projectId=${encodeURIComponent(options.projectId)}`
      : "";
  return axios.get(`${BASE}/ai-feature-model${query}`, { withCredentials: true });
}

export async function updateFeatureModel(featureKey, provider, modelKey) {
  return axios.put(
    `${BASE}/ai-feature-model`,
    { featureKey, provider, modelKey },
    { withCredentials: true }
  );
}

export async function bulkUpdateFeatureModels(updates = []) {
  return axios.put(
    `${BASE}/ai-feature-model`,
    { updates },
    { withCredentials: true }
  );
}

/**
 * Resolve org API key row for a provider/model pair.
 * @param {string} provider
 * @param {string} modelKey
 * @param {string|number|null} [projectId] - When set, permission middleware uses project-scoped roles (GET_TEST_CASE / GET_PROJECT) so project users without org-level get_ai_model can still resolve.
 */
export async function resolveModelForProviderModel(provider, modelKey, projectId = null) {
  const params = { provider, modelKey };
  if (projectId != null && projectId !== "") {
    params.projectId = String(projectId);
  }
  const query = new URLSearchParams(params).toString();
  return axios.get(`${BASE}/ai-feature-model/resolve/meta?${query}`, {
    withCredentials: true,
  });
}
